import { motion } from "framer-motion";
import { Globe, ShieldCheck, Layers, Network, Handshake } from "lucide-react";

const ITEMS = [
  {
    icon: Globe,
    title: "Alcance Global y Logística Propia",
    desc: "Dominamos las rutas de importación, eliminando intermediarios para garantizar los precios más competitivos y disponibilidad inmediata de stock.",
  },
  {
    icon: ShieldCheck,
    title: "Calidad y Respaldo Técnico",
    desc: "Cada equipo que comercializamos cuenta con el aval de nuestro centro de servicio especializado en mantenimiento y reparación.",
  },
  {
    icon: Layers,
    title: "Portafolio Multimarca",
    desc: "Somos agentes y distribuidores autorizados de las marcas líderes, ofreciendo diversidad y repuestos originales para cada categoría electrónica.",
  },
  {
    icon: Network,
    title: "Especialización en Conectividad",
    desc: "Nuestra experiencia técnica en fibra óptica y cableado estructurado nos permite ofrecer soluciones integrales de infraestructura tecnológica.",
  },
  {
    icon: Handshake,
    title: "Flexibilidad Comercial",
    desc: "Adaptamos nuestras condiciones de venta al mayoreo y menudeo, facilitando el crecimiento de negocios locales y el acceso al consumidor final.",
  },
];

export const Atractivos = () => {
  return (
    <section
      id="atractivos"
      data-testid="atractivos-section"
      className="relative py-20 md:py-28 bg-white"
    >
      <div className="absolute inset-0 tech-grid-bg" />
      <div className="relative max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-5">
            <div className="font-mono-tech text-[11px] tracking-[0.32em] uppercase text-[#843C0C] mb-4 flex items-center gap-2">
              <span className="h-px w-8 bg-[#843C0C]" />
              Diferenciadores
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#203864] tracking-tight leading-[1.05]">
              Atractivos de nuestra organización.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-6">
            <p className="text-[#3B3838]/80 text-base md:text-lg leading-relaxed">
              Cinco pilares operativos que nos posicionan como el aliado estratégico de
              importación y distribución tecnológica preferido en México.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#3B3838]/15">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                whileHover={{ y: -4 }}
                className="bg-white p-6 md:p-7 group cursor-default"
                data-testid={`atractivo-card-${i}`}
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="h-11 w-11 bg-[#203864] text-white flex items-center justify-center group-hover:bg-[#843C0C] transition-colors">
                    <Icon size={20} />
                  </div>
                  <span className="font-mono-tech text-[11px] tracking-[0.2em] text-[#843C0C]">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-semibold text-[#203864] text-base md:text-lg leading-snug mb-3 tracking-tight">
                  {item.title}
                </h3>
                <p className="text-sm text-[#3B3838]/75 leading-relaxed">{item.desc}</p>
                <div className="mt-5 h-px bg-[#843C0C]/0 group-hover:bg-[#843C0C] transition-colors" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
